import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import UploadFileCompletedIcon from '@/assets/icons/upload_file_completed.svg?react';
import { FileUploadStatusMessage } from './FileUploadStatusMessage';
import { FileUploadStatusMessageWrapper } from './FileUploadStatusMessageWrapper';

type UploadCompletedProps = {
  filename: string;
};

export const UploadCompleted: FC<UploadCompletedProps> = ({ filename }) => {
  const { t } = useTranslation();

  return (
    <>
      <UploadFileCompletedIcon className='size-5' />

      <FileUploadStatusMessageWrapper>
        <FileUploadStatusMessage message={filename} />
        <FileUploadStatusMessage message={t('data_source_edit:file.progress_bar.upload_completed')} />
      </FileUploadStatusMessageWrapper>
    </>
  );
};
